export const apiBaseUrl = "/api";

export async function parseJsonResponse(res, path = "") {
	const responseText = await res.text();
	try {
		return responseText ? JSON.parse(responseText) : {};
	} catch {
		if (!res.ok) {
			throw new Error(responseText || `HTTP ${res.status}${path ? ` - ${path}` : ""}`);
		}
		throw new Error(`Gecersiz JSON response${path ? ` - ${path}` : ""}`);
	}
}

export async function fetchJson(path, options = {}) {
	const res = await fetch(`${apiBaseUrl}${path}`, options);
	const data = await parseJsonResponse(res, path);
	if (!res.ok) throw new Error(data?.error || `HTTP ${res.status} - ${path}`);
	return data;
}

export function uploadFaturaPdf(file, onProgress) {
	const form = new FormData();
	form.append("filepond", file, file.name);

	const xhr = new XMLHttpRequest();
	xhr.open("POST", `${apiBaseUrl}/upload/fatura`);

	xhr.upload.onprogress = (e) => {
		if (e.lengthComputable && typeof onProgress === "function") {
			onProgress(e.loaded / e.total);
		}
	};

	return new Promise((resolve, reject) => {
		xhr.onload = () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				try {
					const data = JSON.parse(xhr.responseText || "{}");
					resolve(data.serverId || data.filePath || data.path || "");
				} catch {
					reject(new Error("Gecersiz upload cevabi"));
				}
			} else {
				try {
					const data = JSON.parse(xhr.responseText || "{}");
					reject(new Error(data.error || `Upload failed: ${xhr.status}`));
				} catch {
					reject(new Error(xhr.responseText || `Upload failed: ${xhr.status}`));
				}
			}
		};
		xhr.onerror = () => reject(new Error("Network error"));
		xhr.send(form);
	});
}

export async function postJson(path, body = {}) {
	const res = await fetch(`${apiBaseUrl}${path}`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	});
	const data = await parseJsonResponse(res, path);
	if (!res.ok) throw new Error(data?.error || `HTTP ${res.status} - ${path}`);
	return data;
}
